import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const PortalsInUseContainer = styled.div`
  display: flex;
  justify-content: end;
`

export const ContentLayout = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp32};
  align-items: stretch;
`

export const LeftColumn = styled.div`
  flex: 4;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
  min-width: 0;
`

export const RightColumn = styled.div`
  flex: 4;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border-radius: ${props => props.theme.primitives.radius.radius6};
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.disabled.surface};
`
